/**
 * UcPaymentIconsApiService — admin data-access layer for the built-in
 * "Payment Provider Icons" library (Settings → Ultimate Cart Configuration →
 * Payment Provider Icons card).
 *
 * Same ApiService subclassing pattern as UcCrossSellRulesApiService — see
 * that file's docblock for why (getBasicHeaders() auto-attaches
 * Authorization + sw-language-id on every request).
 *
 * Maps 1-to-1 to PaymentIconsAdminController::list().
 */
const ApiService = Shopware.Classes.ApiService;

class UcPaymentIconsApiService extends ApiService {
    constructor(httpClient, loginService, apiEndpoint = 'sellops-uc') {
        super(httpClient, loginService, apiEndpoint);
        this.name = 'ucPaymentIconsApiService';
    }

    /**
     * @returns {Promise<Array<{file: string, label: string}>>}
     */
    getIcons() {
        return this.httpClient
            .get('/sellops-uc/payment-icons', { headers: this.getBasicHeaders() })
            .then(ApiService.handleResponse.bind(ApiService));
    }
}

export default UcPaymentIconsApiService;
